<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-forgot">
      <p class="title title-double-line">パスワードの再設定<span class="mini">-&nbsp;個人識別暗証再設定届&nbsp;-</span></p>

      <div class="description">
        <p>異界舞踏会・アキバトリカルのログインパスワードを再設定いたします。</p>
      </div>

      <PaFrontForm
        :action="'/'"
        :formSet="formSet"
        :submitText="'設定'"
        :submitLoading="submitLoading"
        
        @handleSubmit="handleSubmit"
      />
    </div>
  </section>
</template>

<script>
import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

import FrontPageMixins from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FormValidationControlMixin,
    FrontPageMixins
  ],

  components : {
    PaFrontForm
  },

  data(){
    return {
      submitLoading : false,
      formSet       : {
        password            : {
          label           : 'パスワード',
          description     : ' \
          <p>ログイン時に使用するパスワードです。半角英数字記号8文字以上で指定してください。</p> \
          ',
          validationRules : ['notEmpty', 'max', 'password'],
          inputType       : 'password',
        },
        password_confirmation : {
          label           : 'パスワード再入力',
          description     : ' \
            <p>確認のため、パスワードフィールドに入力したパスワードと同じものを再入力してください。</p>  \
          ',
          validationRules : ['notEmpty', 'max', 'password', 'passwordConfirmation'],
          inputType       : 'password',
        }
      }
    };
  },

  methods : {
    checkRouteParameterValidation(){
      if( (typeof this.$route.params.token !== 'undefined') && (typeof this.$route.params.email !== 'undefined') ){
        return true;
      }

      return false;
    },

    async handleSubmit(){
      this.submitLoading = true;

      if( this.checkFormPreValidation() && this.checkRouteParameterValidation() ){
        this.disabledFields();

        const results = await this.$store.dispatch({
          type                  : 'requests/registration/resetPasswordPost',

          token                 : this.$route.params.token,
          email                 : this.$route.params.email,
          password              : this.formSet['password']['value'],
          password_confirmation : this.formSet['password_confirmation']['value'],
        });
        const validationResult = await this.RESTResultResultValidationGuard(results);

        this.submitLoading = false;
        this.unDisabledFields();

        if(validationResult === true){
          this.flashMessageToScroll({
            status    : 'primary',
            text      : '&nbsp;パスワードの再設定が完了しました。ログイン画面より御接続御願いいたします。',
            autoClose : 5000,
            cancelBtn : true,
          });

          return this.$router.push({name: 'index'});
        }
      }

      this.submitLoading = false;
      this.unDisabledFields();

      this.flashMessageToScroll({
        status    : 'error',
        text      : '&nbsp;入力項目にエラーが存在します。今一度ご確認ください。',
        autoClose : 1800,
        cancelBtn : false,
      });
    }
  },
  async mounted(){
    await this.initializePage();
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/globals.scss";

.pa-section{
  &-registration{
    .pa-forgot{
      
    }
  }
}
</style>